import KVSSignaling from './KVSSignaling';
import { ISignalingClient } from './ISignalingClient';
import { WebRTCSessionConfiguration } from '../types';

/**
 * Signaling client factory.
 */
export default function getSignalingClient(
	sessionConfiguration: WebRTCSessionConfiguration
): ISignalingClient {
	const signalingClient = new KVSSignaling(sessionConfiguration);

	return signalingClient as ISignalingClient;
}
